@if (dialog.active(); as cfg) {
  <div class="pathways-modal-backdrop" (click)="onBackdropClick()">
    <div
      class="pathways-modal-card"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="cfg.title"
      (click)="$event.stopPropagation()"
    >
      <div class="pathways-title-accent-block">
        <h3 class="pathways-modal-title">{{ cfg.title }}</h3>
        <div class="qprime-accent-bar" aria-hidden="true"></div>
      </div>
      <p class="pathways-modal-message">{{ cfg.message }}</p>
      <div class="pathways-modal-actions">
        @if (cfg.mode === 'confirm') {
          <button type="button" class="pathways-btn-secondary" (click)="onCancel()">
            {{ cfg.cancelLabel }}
          </button>
        }
        <button
          type="button"
          [class.pathways-btn-primary]="!cfg.destructive"
          [class.pathways-btn-danger]="cfg.destructive"
          (click)="onConfirm()"
        >
          {{ cfg.confirmLabel }}
        </button>
      </div>
    </div>
  </div>
}
